<div
  *ngIf="sessionDetails"
  class="session-details tw-h-full">
  <!-- Tab Navigation -->
  <mat-tab-group
    class="tw-h-full"
    [(selectedIndex)]="selectedTabIndex"
    (selectedTabChange)="onTabChange($event.index)">

    <!-- Summary Tab -->
    <mat-tab [label]="labels.summary || 'Summary'">
      <div class="tw-py-3">
        <!-- Summary Stats using app-key-value-block -->
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-mb-6">
          <app-key-value-block
            *ngFor="let stat of summaryStats"
            [key]="stat.label"
            [value]="stat.value"
            [bgColor]="stat.bgColor || 'bg-blue-50'"
            [copyToClipboard]="true">
          </app-key-value-block>
        </div>

        <!-- Session Info using app-key-value-block -->
        <div>
          <h3 class="tw-text-lg tw-font-medium tw-mb-4 text-grey-400 body-1">Session Information</h3>
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
            <app-key-value-block
              *ngFor="let info of sessionInfoData"
              [key]="info.label"
              [value]="info.value"
              [bgColor]="info.bgColor"
              [copyToClipboard]="true">
            </app-key-value-block>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Events Tab -->
    <mat-tab [label]="labels.events || 'Events'">
      <div class="tw-py-3">
        <!-- Events Table (Desktop) -->
        <azzurro-table
          *ngIf="eventsPaginationConfig"
          id="session-events-table"
          [data$]="eventsData$"
          [columns]="eventsColumns"
          [pagination]="true"
          [filterEnabled]="true"
          [showColumnToggleButton]="false"
          [uiFramework]="'material'"
          [mode]="'client'"
          [paginationConfig]="eventsPaginationConfig"
          [labels]="{
            search: 'Filter events',
            noData: 'No events found',
            noResults: 'No events found'
          }">
        </azzurro-table>
        <!-- Events List (Mobile) -->
        <azzurro-table
          *ngIf="eventsPaginationConfig"
          id="session-events-list"
          [data$]="eventsData$"
          [columns]="eventsColumns"
          [pagination]="true"
          [filterEnabled]="true"
          [showColumnToggleButton]="false"
          [uiFramework]="'ionic'"
          [mode]="'client'"
          [paginationConfig]="eventsPaginationConfig"
          [labels]="{
            search: 'Filter events',
            noData: 'No events found',
            noResults: 'No events found'
          }">
        </azzurro-table>
      </div>
    </mat-tab>

    <!-- SGP Commands Tab -->
    <mat-tab [label]="labels.sgpCommands || 'SGP Commands'">
      <div class="tw-py-3">
        <!-- Header with Export Button -->
        <div class="tw-flex tw-justify-end tw-items-center tw-mb-4">
          <button
            type="button"
            class="custom-mat-button-primary custom-mat-button-border"
            mat-button
            (click)="exportSgpCommandsAsText()">
            <mat-icon class="m-0">download</mat-icon>
            Export
          </button>
        </div>

        <!-- SGP Commands Table (Desktop) -->
        <azzurro-table
          *ngIf="sgpCommandsPaginationConfig"
          id="session-sgp-commands-table"
          [data$]="sgpCommandsData$"
          [columns]="sgpCommandsColumns"
          [pagination]="true"
          [filterEnabled]="true"
          [showColumnToggleButton]="false"
          [uiFramework]="'material'"
          [mode]="'client'"
          [paginationConfig]="sgpCommandsPaginationConfig"
          [labels]="{
            search: 'Filter SGP commands',
            noData: 'No SGP commands found',
            noResults: 'No SGP commands found'
          }">
        </azzurro-table>
        <!-- SGP Commands List (Mobile) -->
        <azzurro-table
          *ngIf="sgpCommandsPaginationConfig"
          id="session-sgp-commands-list"
          [data$]="sgpCommandsData$"
          [columns]="sgpCommandsColumns"
          [pagination]="true"
          [filterEnabled]="true"
          [showColumnToggleButton]="false"
          [uiFramework]="'ionic'"
          [mode]="'client'"
          [paginationConfig]="sgpCommandsPaginationConfig"
          [labels]="{
            search: 'Filter SGP commands',
            noData: 'No SGP commands found',
            noResults: 'No SGP commands found'
          }">
        </azzurro-table>
      </div>
    </mat-tab>

    <!-- Device Snapshots Tab -->
    <mat-tab [label]="labels.deviceSnapshot || 'Device Snapshots'">
      <div class="tw-py-3">

        <!-- Show new pre/post upgrade snapshots if available -->
        <div
          *ngIf="hasPreUpgradeSnapshot || hasPostUpgradeSnapshot; else legacySnapshot">

          <!-- Navigation buttons for pre/post snapshots -->
          <div
            *ngIf="hasBothSnapshots"
            class="tw-flex tw-justify-center tw-mb-6">
            <div class="tw-bg-gray-100 tw-rounded-lg tw-p-1 tw-inline-flex">
              <button
                type="button"
                class="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-md tw-transition-colors"
                [class.tw-bg-white]="selectedSnapshotView === 'pre'"
                [class.tw-text-blue-600]="selectedSnapshotView === 'pre'"
                [class.tw-text-gray-600]="selectedSnapshotView !== 'pre'"
                (click)="selectedSnapshotView = 'pre'">
                Pre-Upgrade
              </button>
              <button
                type="button"
                class="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-md tw-transition-colors"
                [class.tw-bg-white]="selectedSnapshotView === 'post'"
                [class.tw-text-green-600]="selectedSnapshotView === 'post'"
                [class.tw-text-gray-600]="selectedSnapshotView !== 'post'"
                (click)="selectedSnapshotView = 'post'">
                Post-Upgrade
              </button>
              <button
                type="button"
                class="tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-md tw-transition-colors"
                [class.tw-bg-white]="selectedSnapshotView === 'comparison'"
                [class.tw-text-purple-600]="selectedSnapshotView === 'comparison'"
                [class.tw-text-gray-600]="selectedSnapshotView !== 'comparison'"
                (click)="selectedSnapshotView = 'comparison'">
                Comparison
              </button>
            </div>
          </div>

          <!-- Pre-Upgrade Snapshot -->
          <div *ngIf="(selectedSnapshotView === 'pre' || !hasBothSnapshots) && hasPreUpgradeSnapshot">
            <h3 class="tw-text-lg tw-font-medium tw-mb-4 text-blue-600 body-1">
              <span class="tw-w-3 tw-h-3 tw-bg-blue-500 tw-rounded-full tw-inline-block tw-mr-2"></span>
              Pre-Upgrade Snapshot
            </h3>

            <!-- Basic Pre-Upgrade Info -->
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-mb-6">
              <app-key-value-block
                *ngFor="let item of preUpgradeSnapshotData"
                [key]="item.label"
                [value]="item.value"
                [bgColor]="item.bgColor">
              </app-key-value-block>
            </div>

            <!-- Technical Pre-Upgrade Details -->
            <div
              *ngIf="preUpgradeSnapshotTechnicalData.length > 0"
              class="tw-mt-8">
              <div class="tw-space-y-6">
                <div
                  *ngFor="let item of preUpgradeSnapshotTechnicalData"
                  class="tw-bg-white border-grey-200 border-1 tw-rounded-lg tw-overflow-hidden">
                  <!-- Header -->
                  <div class="tw-bg-blue-50 tw-px-4 tw-py-3 tw-border-b border-grey-100">
                    <h5 class="text-blue-600 text-uppercase body-2 tw-flex tw-items-center">
                      <span class="tw-w-2 tw-h-2 tw-bg-blue-500 tw-rounded-full tw-mr-3"></span>
                      Pre-Upgrade: {{ item.label }}
                    </h5>
                  </div>
                  <!-- Content -->
                  <div class="tw-p-4">
                    <div class="tw-max-h-96 tw-overflow-y-auto border-1 radius-4 border-grey-100">
                      <pre class="tw-p-4 tw-text-xs tw-text-gray-400 tw-font-mono tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words">{{ item.value }}</pre>
                    </div>
                    <!-- Copy button -->
                    <div class="tw-mt-3 tw-flex tw-justify-end">
                      <ngx-copy-to-clipboard
                        tooltip="Copy to clipboard"
                        copiedTooltip="Copied!"
                        size="sm"
                        additionalClasses="body-1 text-blue-600"
                        [textToCopy]="item.value">
                        Copy
                      </ngx-copy-to-clipboard>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Post-Upgrade Snapshot -->
          <div *ngIf="(selectedSnapshotView === 'post' || !hasBothSnapshots) && hasPostUpgradeSnapshot">
            <h3 class="tw-text-lg tw-font-medium tw-mb-4 text-green-600 body-1">
              <span class="tw-w-3 tw-h-3 tw-bg-green-500 tw-rounded-full tw-inline-block tw-mr-2"></span>
              Post-Upgrade Snapshot
            </h3>

            <!-- Basic Post-Upgrade Info -->
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-mb-6">
              <app-key-value-block
                *ngFor="let item of postUpgradeSnapshotData"
                [key]="item.label"
                [value]="item.value"
                [bgColor]="item.bgColor">
              </app-key-value-block>
            </div>

            <!-- Technical Post-Upgrade Details -->
            <div
              *ngIf="postUpgradeSnapshotTechnicalData.length > 0"
              class="tw-mt-8">
              <div class="tw-space-y-6">
                <div
                  *ngFor="let item of postUpgradeSnapshotTechnicalData"
                  class="tw-bg-white border-grey-200 border-1 tw-rounded-lg tw-overflow-hidden">
                  <!-- Header -->
                  <div class="tw-bg-green-50 tw-px-4 tw-py-3 tw-border-b border-grey-100">
                    <h5 class="text-green-600 text-uppercase body-2 tw-flex tw-items-center">
                      <span class="tw-w-2 tw-h-2 tw-bg-green-500 tw-rounded-full tw-mr-3"></span>
                      Post-Upgrade: {{ item.label }}
                    </h5>
                  </div>
                  <!-- Content -->
                  <div class="tw-p-4">
                    <div class="tw-max-h-96 tw-overflow-y-auto border-1 radius-4 border-grey-100">
                      <pre class="tw-p-4 tw-text-xs tw-text-gray-400 tw-font-mono tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words">{{ item.value }}</pre>
                    </div>
                    <!-- Copy button -->
                    <div class="tw-mt-3 tw-flex tw-justify-end">
                      <ngx-copy-to-clipboard
                        tooltip="Copy to clipboard"
                        copiedTooltip="Copied!"
                        size="sm"
                        additionalClasses="body-1 text-green-600"
                        [textToCopy]="item.value">
                        Copy
                      </ngx-copy-to-clipboard>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Comparison View -->
          <div *ngIf="selectedSnapshotView === 'comparison' && hasBothSnapshots">
            <h3 class="tw-text-lg tw-font-medium tw-mb-4 text-purple-600 body-1">
              <span class="tw-w-3 tw-h-3 tw-bg-purple-500 tw-rounded-full tw-inline-block tw-mr-2"></span>
              Pre vs Post Upgrade Comparison
            </h3>

            <!-- Comparison Data -->
            <div
              *ngIf="batteryModuleComparisonData.length > 0"
              class="tw-space-y-6">
              <div
                *ngFor="let item of batteryModuleComparisonData"
                class="tw-bg-white border-grey-200 border-1 tw-rounded-lg tw-overflow-hidden"
                [class.tw-border-orange-300]="item.hasChange"
                [class.tw-border-green-300]="!item.hasChange">
                <!-- Header -->
                <div
                  class="tw-px-4 tw-py-3 tw-border-b border-grey-100"
                  [class.tw-bg-orange-50]="item.hasChange"
                  [class.tw-bg-green-50]="!item.hasChange">
                  <h5
                    class="text-uppercase body-2 tw-flex tw-items-center"
                    [class.text-orange-600]="item.hasChange"
                    [class.text-green-600]="!item.hasChange">
                    <span
                      class="tw-w-2 tw-h-2 tw-rounded-full tw-mr-3"
                      [class.tw-bg-orange-500]="item.hasChange"
                      [class.tw-bg-green-500]="!item.hasChange"></span>
                    {{ item.label }}
                    <span
                      class="tw-ml-2 tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium"
                      [class.tw-bg-orange-100]="item.hasChange"
                      [class.tw-text-orange-800]="item.hasChange"
                      [class.tw-bg-green-100]="!item.hasChange"
                      [class.tw-text-green-800]="!item.hasChange">
                      {{ item.hasChange ? 'Changed' : 'No Changes' }}
                    </span>
                  </h5>
                </div>
                <!-- Content -->
                <div class="tw-p-4">
                  <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">
                    <!-- Pre-upgrade column -->
                    <div>
                      <h6 class="tw-text-sm tw-font-medium tw-text-blue-600 tw-mb-2">Pre-Upgrade</h6>
                      <div class="tw-max-h-96 tw-overflow-y-auto border-1 radius-4 border-blue-200">
                        <pre class="tw-p-3 tw-text-xs tw-text-gray-400 tw-font-mono tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words">{{ item.preBatteryValue }}</pre>
                      </div>
                    </div>
                    <!-- Post-upgrade column -->
                    <div>
                      <h6 class="tw-text-sm tw-font-medium tw-text-green-600 tw-mb-2">Post-Upgrade</h6>
                      <div class="tw-max-h-96 tw-overflow-y-auto border-1 radius-4 border-green-200">
                        <pre class="tw-p-3 tw-text-xs tw-text-gray-400 tw-font-mono tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words">{{ item.postBatteryValue }}</pre>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Legacy single snapshot view (for backward compatibility) -->
        <ng-template #legacySnapshot>
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-mb-6">
            <app-key-value-block
              *ngFor="let item of basicDeviceSnapshotData"
              [key]="item.label"
              [value]="item.value"
              [bgColor]="item.bgColor">
            </app-key-value-block>
          </div>

          <!-- Technical Details -->
          <div
            *ngIf="technicalDeviceSnapshotData.length > 0"
            class="tw-mt-8">
            <div class="tw-space-y-6">
              <div
                *ngFor="let item of technicalDeviceSnapshotData"
                class="tw-bg-white border-grey-200 border-1 tw-rounded-lg tw-overflow-hidden">
                <!-- Header -->
                <div class="tw-bg-gray-50 tw-px-4 tw-py-3 tw-border-b border-grey-100">
                  <h5 class="text-grey-400 text-uppercase body-2 tw-flex tw-items-center">
                    <span class="tw-w-2 tw-h-2 tw-bg-blue-500 tw-rounded-full tw-mr-3"></span>
                    {{ item.label }}
                  </h5>
                </div>

                <!-- Content -->
                <div class="tw-p-4">
                  <div class="tw-max-h-96 tw-overflow-y-auto border-1 radius-4 border-grey-100">
                    <pre class="tw-p-4 tw-text-xs tw-text-gray-400 tw-font-mono tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words">{{ item.value }}</pre>
                  </div>

                  <!-- Copy button -->
                  <div class="tw-mt-3 tw-flex tw-justify-end">
                    <ngx-copy-to-clipboard
                      tooltip="Copy to clipboard"
                      copiedTooltip="Copied!"
                      size="sm"
                      additionalClasses="body-1 text-grey-400"
                      [textToCopy]="item.value">
                      Copy
                    </ngx-copy-to-clipboard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

      </div>
    </mat-tab>
  </mat-tab-group>
</div>